export default "__VITE_ASSET__BENUM3kF__"